var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgDrawSelected(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#e1087e"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#e1087e",
    strokeWidth: 1.2,
    rx: 15.5
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M21 24a.97.97 0 01-.712-.288A.97.97 0 0120 23v-5q0-.424.288-.712A.97.97 0 0121 17h2q.424 0 .712.288.288.287.288.712v5q0 .424-.288.712A.97.97 0 0123 24zm-6 0a.97.97 0 01-.713-.288A.97.97 0 0114 23V9q0-.424.287-.713A.97.97 0 0115 8h2q.424 0 .712.287Q18 8.576 18 9v14q0 .424-.288.712A.97.97 0 0117 24zm-6 0a.97.97 0 01-.713-.288A.97.97 0 018 23v-9q0-.424.287-.713A.97.97 0 019 13h2q.424 0 .713.287.287.288.287.713v9q0 .424-.287.712A.97.97 0 0111 24z"
  }))));
}
export default SvgDrawSelected;